import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import * as r from '../../constants/routes';
import { setd_inv010, setd_inv170 } from '../slices/appStateSlice';

const setHeaders = (headers: Headers) => {
    headers.set('Content-Type', 'application/json');
    headers.set('x-applicat-apikey', process.env.REACT_APP_API_KEY!);
    return headers;
};

const baseQueryInterceptor: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError,
    {},
    FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.data) {
        const authorizations = (result.data as any).authorization;
        const d_inv010 = authorizations.find((a: any) => a.functName === "d_inv010") ? authorizations.find((a: any) => a.functName === "d_inv010") : {}
        api.dispatch(setd_inv010(d_inv010));
        const d_inv170 = authorizations.find((a: any) => a.functName === "d_inv170") ? authorizations.find((a: any) => a.functName === "d_inv170") : {}
        api.dispatch(setd_inv170(d_inv170));
    }

    return result
}

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        return setHeaders(headers);
    }
});

export const loginApi = createApi({
    reducerPath: 'loginApi',
    baseQuery: baseQueryInterceptor,
    endpoints: (builder) => ({
        loginWithCredentials: builder.mutation({
            query: ({ user, password }) => ({ url: `${r.LOGIN}?modules=approbweb,inventaire`, method: 'POST', body: { user, password } }),
            transformResponse: (apiResponse, meta) => {
                return { body: apiResponse, headers: meta!.response!.headers };
            }
        }),
        loginWithToken: builder.query({
            query: (token) => (`${r.LOGIN}/${token}?modules=approbweb,inventaire`),
            transformResponse: (apiResponse, meta) => {
                return { body: apiResponse, headers: meta!.response!.headers };
            }
        }),
    })
});

export const { useLoginWithCredentialsMutation, useLazyLoginWithTokenQuery } = loginApi;